<template>
  <div class="error">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="error-container">
            <div class="error__headline">
              {{ $t('pages.error.notBookable.headline') }}
            </div>
            <div class="error__copy">
              <p>
                {{ $t('pages.error.notBookable.copy') }}
              </p>
              <CiButton class="navigation__button button--primary" @click="ctaClicked()">
                <span>{{ $t('pages.error.notBookable.button') }}</span>
                <iconArrowWhite class="icon icon--animated"></iconArrowWhite>
              </CiButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CiButton } from '@/components'
import iconArrowWhite from '@/assets/icons/arrow-white.svg'

export default {
  name: 'NotBookable',
  components: {
    CiButton,
    iconArrowWhite,
  },
  props: {
    noSeasons: { type: Boolean, default: false, required: false },
  },
  methods: {
    ctaClicked() {
      window.location.href = this.$t('pages.error.notBookable.link')
    },
  },
}
</script>

<style scoped lang="scss">
.error {
  min-height: 100vh;
  background-color: rgba(155, 155, 155, 0.1);
}

.error-container {
  max-width: 740px;
  text-align: center;
  margin: 50px auto 0 auto;

  @include media-breakpoint-up(md) {
    margin: 150px auto 0 auto;
  }
}

.error__headline {
  @include font('gotham_mediumregular');
  @include font-format(1.8rem, 2rem);

  margin: 20px 0 10px 0;

  @include media-breakpoint-up(md) {
    @include font-format(2.25rem, 2.6rem);
  }
}

.error__copy {
  button {
    margin: 0 auto;
  }
  p {
    @include media-breakpoint-up(md) {
      margin: 50px 0;
    }
  }
}
</style>
